import React, { useEffect } from 'react'
import BasicModalWindow from '../../components/BasicModalWIndow'
import { IAxiosDefaultDataObject } from '../../config'
import { Dispatch, UnknownAction } from '@reduxjs/toolkit'
import { addNewSection, updateSection } from './sectionsSlice'
import SectionsApp, { ISectionModel } from './SectionsApp'
import AdminDynamicCreateOrUpdatePage from '../admin/AdminDynamicCreateOrUpdatePage'
import GenerateForm from '../../components/Form/GenerateForm'
import { addNewForm, createOrUpdateElementData } from '../../components/Form/formsSlice'
import { useDispatch } from 'react-redux'
import DynamicForm, { IRequiredField } from '../../components/Form/DynamicForm'

interface INewSectionModalProps {
    open: boolean,
    handleClose: () => void,
    warehouseId: number,
    handleOnSuccess: () => void,
}

export default function NewSectionModal(props: INewSectionModalProps) {

    const dispatch = useDispatch()

    const {
        open,
        warehouseId,
        handleOnSuccess,
    } = props

    const sectionsApp = new SectionsApp()

    const form = sectionsApp.formConfig.form

    const elementsData = DynamicForm.useReturnAllFormsData()
    const singleElemDataValue = (name: string) => DynamicForm.returnSingleFormElementData(name, elementsData).value

    /**
     * Create form elem data
     */
    const createFormElemData = () => {
        form.elements.map((elem) => dispatch(createOrUpdateElementData({
            name: elem.id,
            value: elem.id == sectionsApp.elemPrefix + "warehouse_id" ? warehouseId : "",
        })))
    }

    /**
     * Reset form
     */
    const resetForm = () => {
        createFormElemData()
        DynamicForm.createOrUpdateFormMessage(form.name, { shown: false, type: "success", message: "" }, dispatch)
    }

    /**
     * Handle close modal
     */
    const handleClose = () => {
        resetForm()
        props.handleClose()
    }

    /**
     * Create Form
     */
    useEffect(() => {

        dispatch(addNewForm({
            name: form.name,
            elements: form.elements
        }))

        createFormElemData()

    }, [])

    /**
     * Handle submit
     */
    const handleSubmit = () => {

        let data: IAxiosDefaultDataObject = {}

        /**
         * Fill data
         */
        form.elements.map((elem) => {
            let dataName = elem.id.replace(sectionsApp.elemPrefix, "")
            data[dataName] = singleElemDataValue(elem.id)
        })

        let requiredFields: IRequiredField[] = sectionsApp.formConfig.requiredFields

        DynamicForm.resetRequiredFieldsHelperText(requiredFields, elementsData, dispatch)
        const verifyForm = DynamicForm.verifyForm(elementsData, requiredFields)

        if (verifyForm.isValid){
            DynamicForm.updateFormLoadingStatus(form.name, true, dispatch)

            sectionsApp.createNewInstance(data)
                .then(response => {

                    const { data } = response
                    const message = data.message ? data.message : "Success!"

                    DynamicForm.updateFormLoadingStatus(form.name, false, dispatch)
                    DynamicForm.createOrUpdateFormMessage(form.name, { shown: true, type: "success", message: message }, dispatch)

                    dispatch(addNewSection(data))

                    resetForm()
                    handleOnSuccess()
                    handleClose()

                })
                .catch(error => {

                    console.log(error)
                    const message = error.response.data.message ? error.response.data.message : "Fatal Error"

                    DynamicForm.updateFormLoadingStatus(form.name, false, dispatch)
                    DynamicForm.createOrUpdateFormMessage(form.name, { shown: true, type: "error", message: message }, dispatch)

                })
        }else{
            DynamicForm.updateRequiredFieldsHelperText(verifyForm.fields, elementsData, dispatch)
        }

    }

    return(
        <BasicModalWindow
            shown={open}
            title={"New Section"}
            handleClose={handleClose}
            size="lg"
            actionButtons={[
                {
                    label: "Create New Section",
                    color: "success",
                    onClick: () => handleSubmit(),
                },
                {
                    label: "Cancel",
                    color: "error",
                    onClick: () => handleClose()
                }
            ]}
            actionButtonsBottom
        >
            <div className="quick-element-preview-content" style={{ marginTop: 15 }}>
                <GenerateForm name={form.name} />
            </div>
        </BasicModalWindow>
    )
}